export enum PillButtonSize {
  MEDIUM,
  SMALL,
}

export interface PillButtonDropdownItems {
  id: string;
  text: string;
}
